import React from "react";
var __jsx = React.createElement;
import BreadCrumb from "@componentsShared/BreadCrumb";
import stl from "./Banner.module.css";
import { useTranslation } from "@i18n";
import { useLang } from "@/common/Contexts/LanguageContext";
import useHelpers from "@hooks/useHelpers";
var Banner = function Banner(_ref) {
  var cityName = _ref.cityName;
  var lang = useLang();
  var _useTranslation = useTranslation(["web_city", "web_common"]),
    t = _useTranslation.t;
  var _useHelpers = useHelpers(),
    createUrl = _useHelpers.createUrl;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: stl.BC_container
  }, /*#__PURE__*/React.createElement(BreadCrumb, {
    className: stl.brdCrmb,
    links: [{
      title: t("المدن", {
        ns: "web_common"
      }),
      link: createUrl("/city")
    }, {
      title: cityName
    }]
  }), /*#__PURE__*/React.createElement("h1", null, t("سيارات للبيع في {{cityName}}", {
    ns: "web_city",
    cityName: cityName
  })), /*#__PURE__*/React.createElement("p", null, " ", t("نوصلك المركبة الي بتشتريها من سيارة إلى {{cityName}}", {
    ns: "web_city",
    cityName: cityName
  }))));
};
export default Banner;